import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[noSpaces]',
  standalone: true,
})
export class NoSpacesDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    // Block spacebar key (key === ' ')
    if (key === ' ') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');

    // Block pasting if the text contains spaces
    if (/\s/.test(pastedText)) {
      event.preventDefault();
    }
  }
}